import { render, staticRenderFns } from "./siteDown.vue?vue&type=template&id=0a062241&scoped=true"
import script from "./siteDown.vue?vue&type=script&lang=js"
export * from "./siteDown.vue?vue&type=script&lang=js"
import style0 from "./siteDown.vue?vue&type=style&index=0&id=0a062241&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a062241",
  null
  
)

export default component.exports